module.exports = __webpack_public_path__ + "content/4c8f447011eef80831b45edb1e5971e0.ttf";